import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IrisButtonModule } from '@sondermind/iris/button';

import { IrisEmptyStateComponent } from './empty-state.component';

@NgModule({
  declarations: [
    IrisEmptyStateComponent
  ],
  exports: [
    IrisEmptyStateComponent
  ],
  imports: [
    CommonModule,
    IrisButtonModule
  ]
})
export class IrisEmptyStateModule { }
